import { render, staticRenderFns } from "./FilterRange.vue?vue&type=template&id=24b6c76e&scoped=true&"
import script from "./FilterRange.vue?vue&type=script&lang=ts&"
export * from "./FilterRange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6c76e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
installComponents(component, {VRangeSlider})
